import { apiV2 } from '../actions';
import { handleError } from '../utils/commons';

export const fetchInitiativeLogs = async (initiativeId) => {
    try {
        const response = await apiV2.get(`/marketing-initiatives/${initiativeId}/logs`);
        return response.data;
    } catch (error) {
        handleError(error);

        return [];
    }
};

export const extendInitiative = async (initiative, userId, daysToExtend, callback) => {
    try {
        const response = await apiV2.put(`/marketing-initiatives/${initiative.id}/extend`, {
            user_id: userId,
            days_to_extend: daysToExtend,
        });

        callback(response.data, initiative.code, daysToExtend);
    } catch (error) {
        handleError(error);
    }
};
